import HomeMenuComponent from '@/components/home-menu/home-menu.component';
import { INivel } from '@/shared/insaculacion/entity-commons/entity.factory';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import { NRecomendadoEnum } from '@/shared/model/enumerations/nivel-recomendado-enum.model';
import { Dictamen } from '@/shared/model/respuesta.model';
import { Revision } from '@/shared/model/revision.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapMutations } from 'vuex';
import Dictamen2026Mixin from '../mixins/dictamen-2026-mixin';
import { maxLength, minLength, requiredIf } from 'vuelidate/lib/validators';

const CARACTERES_MINIMOS_DICTAMEN = 500;
const CARACTERES_MAXIMOS_DICTAMEN = 4000;

const validations: any = {
  dictamenNegativo: {
    comentarios: {
      required: requiredIf(function (this: any) {
        return this.mostrarComentariosDictamenRequerido;
      }),
      min: minLength(CARACTERES_MINIMOS_DICTAMEN),
      max: maxLength(CARACTERES_MAXIMOS_DICTAMEN),
    },
  },
};
@Component({
  computed: {
    ...mapGetters(['dictamen', 'evaluacion', 'revisorSeleccionado']),
  },
  methods: {
    ...mapMutations(['setDictamen', 'setEvaluacion']),
  },
})
export default class Dictamen2026Component extends mixins(HomeMenuComponent, Dictamen2026Mixin) {
  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public revision: Revision;

  @Prop({ required: false })
  public solucion: Solucion;

  @Prop({ required: false, default: true })
  public evaluacionIndividual: boolean;

  public dictamenEmerito: any = {
    comentarios: '',
  };

  public aceptada = EstadoRevision.ACEPTADA;
  public revisada = EstadoRevision.REVISADA;

  setDictamen!: (dictamen: Dictamen) => void;

  setEvaluacion!: (evaluacion: INivel) => void;

  public readonly dictamen: Dictamen;

  public readonly evaluacion: INivel;

  public readonly revisorSeleccionado: number;

  public idNoAprobado = NRecomendadoEnum.NO_APROBADO;

  public dictamenPositivo: string[] = ['1', '2', '3', '4'];

  mounted(): void {
    this.get();
  }

  public get(): void {
    if (!this.solicitud || !this.revision) {
      return;
    }

    const respuesta: any = this.revision?.respuesta || {};
    const properties: any = respuesta?.properties || respuesta || {};

    if (this.revision?.respuesta?.dictamen && Object.keys(this.revision?.respuesta?.dictamen).length !== 0) {
      this.dictamenNegativo = {
        comentarios: this.revision?.respuesta?.dictamen?.comentarios,
      };
    }

    const evaluacionGuardada = properties?.evaluacion || respuesta?.evaluacion || this.evaluacion || {};

    if (evaluacionGuardada?.id && this.revision?.respuesta) {
      this.revision.respuesta.evaluacion = evaluacionGuardada;
    }
  }

  get comisionDictamen(): string {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return properties?.comision || '_____';
  }

  get areaDictamen(): string {
    const solicitudAny: any = this.solicitud;

    return (
      solicitudAny?.SOLICITUD_RIZOMA?.areaConocimiento?.area?.nombre ||
      solicitudAny?.properties?.SOLICITUD_RIZOMA?.areaConocimiento?.area?.nombre ||
      '_____'
    );
  }

  /**
   * Obtiene la clave del área de conocimiento.
   */
  get areaClaveDictamen(): string {
    const solicitudAny: any = this.solicitud;

    return (
      solicitudAny?.SOLICITUD_RIZOMA?.areaConocimiento?.area?.clave ||
      solicitudAny?.properties?.SOLICITUD_RIZOMA?.areaConocimiento?.area?.clave ||
      '_____'
    );
  }

  /**
   * Obtiene la clave del área de conocimiento en número romano.
   */
  get areaClaveRomanaDictamen(): string {
    const clave = String(this.areaClaveDictamen || '');

    const numerosRomanos: Record<string, string> = {
      '1': 'I',
      '2': 'II',
      '3': 'III',
      '4': 'IV',
      '5': 'V',
      '6': 'VI',
      '7': 'VII',
      '8': 'VIII',
      '9': 'IX',
    };

    return numerosRomanos[clave] || '_____';
  }

  /**
   * Obtiene el nivel de evaluación con redacción según género.
   */
  get nivelEvaluacionDictamen(): string {
    const nivelId = this.idEvaluacionParaDictamen;
    const esFemenino = this.esGeneroFemeninoDictamen;

    const nivelesPorGenero: Record<string, string> = {
      '1': esFemenino ? 'Candidata' : 'Candidato',
      '2': esFemenino ? 'Investigadora Nacional Nivel I' : 'Investigador Nacional Nivel I',
      '3': esFemenino ? 'Investigadora Nacional Nivel II' : 'Investigador Nacional Nivel II',
      '4': esFemenino ? 'Investigadora Nacional Nivel III' : 'Investigador Nacional Nivel III',
      '5': 'No Aprobado',
    };

    return nivelesPorGenero[nivelId] || '_____';
  }

  /**
   * Obtiene el género de la persona solicitante.
   *
   * Puede venir desde:
   * - solicitud.solicitante.genero
   * - SOLICITUD_RIZOMA.solicitante.sexo.nombre
   */
  get generoSolicitanteDictamen(): string {
    const solicitudAny: any = this.solicitud || {};

    return String(
      solicitudAny?.solicitante?.genero ||
        this.solicitudRizomaDictamen?.solicitante?.sexo?.nombre ||
        solicitudAny?.properties?.SOLICITUD_RIZOMA?.solicitante?.sexo?.nombre ||
        ''
    ).toUpperCase();
  }

  /**
   * Indica si la persona solicitante es mujer.
   */
  get esGeneroFemeninoDictamen(): boolean {
    return this.generoSolicitanteDictamen === 'FEMENINO' || this.generoSolicitanteDictamen === 'F';
  }

  /**
   * Indica si la persona solicitante es hombre.
   */
  get esGeneroMasculinoDictamen(): boolean {
    return this.generoSolicitanteDictamen === 'MASCULINO' || this.generoSolicitanteDictamen === 'M';
  }

  get fraccionArticulo19Dictamen(): string {
    const nivelId = this.idEvaluacionParaDictamen;

    const fraccionesPorNivel: any = {
      '1': 'I', // Candidato
      '2': 'II', // Investigador Nacional Nivel I
      '3': 'III', // Investigador Nacional Nivel II
      '4': 'IV', // Investigador Nacional Nivel III
    };

    return fraccionesPorNivel[nivelId] || '_____';
  }

  get descripcionArticulo19Dictamen(): string {
    const nivelId = this.idEvaluacionParaDictamen;
    const esFemenino = this.esGeneroFemeninoDictamen;

    const descripcionesPorNivel: Record<string, string> = {
      '1': esFemenino ? 'Candidata' : 'Candidato',
      '2': esFemenino ? 'Investigadora Nacional Nivel I' : 'Investigador Nacional Nivel I',
      '3': esFemenino ? 'Investigadora Nacional Nivel II' : 'Investigador Nacional Nivel II',
      '4': esFemenino ? 'Investigadora Nacional Nivel III' : 'Investigador Nacional Nivel III',
    };

    return descripcionesPorNivel[nivelId] || '_____';
  }

  get evaluacionDictamen(): INivel {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return properties?.evaluacion || this.evaluacion || {};
  }

  get solicitudRizomaActual(): any {
    const solicitudAny: any = this.solicitud;

    return solicitudAny?.SOLICITUD_RIZOMA || solicitudAny?.properties?.SOLICITUD_RIZOMA || {};
  }

  get tipoPerfilDictamenId(): string {
    return this.solicitud.SOLICITUD_RIZOMA.tipoPerfil.id;
  }

  get esPerfilInvestigacionCienciaBasica(): boolean {
    return this.tipoPerfilDictamenId === 'a' && this.esAprobado;
  }

  get idEvaluacionParaDictamen(): string {
    const respuesta: any = this.revision?.respuesta || {};

    return String(respuesta?.evaluacion?.id || '');
  }

  get esAprobado(): boolean {
    return this.dictamenPositivo.includes(this.idEvaluacionParaDictamen);
  }

  get esPerfilDesarrolloTecnologicoInnovacion(): boolean {
    return this.tipoPerfilDictamenId === 'c' && this.esAprobado;
  }

  get esPerfilMixto(): boolean {
    return this.tipoPerfilDictamenId === 'd' && this.esAprobado;
  }

  /**
   * Obtiene el nivel de excepción guardado en la revisión.
   *
   * Viene de:
   * revision.respuesta.properties.nivelExcepcion
   *
   * Ejemplo:
   * {
   *   id: "4",
   *   nombre: "Investigador Nacional Nivel III"
   * }
   */
  get nivelExcepcionDictamen(): INivel {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return properties?.nivelExcepcion || {};
  }

  /**
   * Obtiene el nombre del nivel de excepción para pintarlo en el dictamen,
   * ajustando Investigadora / Investigador según el género de la persona solicitante.
   */
  get nombreNivelExcepcionDictamen(): string {
    const nivelId = String(this.nivelExcepcionDictamen?.id || '');
    const esFemenino = this.esGeneroFemeninoDictamen;

    const nivelesPorGenero: Record<string, string> = {
      '1': esFemenino ? 'Candidata' : 'Candidato',
      '2': esFemenino ? 'Investigadora Nacional Nivel I' : 'Investigador Nacional Nivel I',
      '3': esFemenino ? 'Investigadora Nacional Nivel II' : 'Investigador Nacional Nivel II',
      '4': esFemenino ? 'Investigadora Nacional Nivel III' : 'Investigador Nacional Nivel III',
    };

    return nivelesPorGenero[nivelId] || this.nivelExcepcionDictamen?.nombre || '_____';
  }

  /**
   * Obtiene el id del tipo de perfil de la solicitud.
   *
   * a = Perfil con Énfasis en Investigación de Ciencia Básica y de Frontera o Incidencia
   * c = Perfil con Énfasis en Desarrollo Tecnológico e Innovación
   * d = Perfil Mixto
   */
  get tipoPerfilIdDictamen(): string {
    return String(this.solicitudRizomaDictamen?.tipoPerfil?.id || '').toLowerCase();
  }

  /**
   * Indica si el perfil permite dictamen de excepción.
   *
   * Aplica para:
   * a = Ciencia Básica y de Frontera o Incidencia
   * c = Desarrollo Tecnológico e Innovación
   * d = Perfil Mixto
   */
  get esPerfilConExcepcionDictamen(): boolean {
    return ['a', 'c', 'd'].includes(this.tipoPerfilIdDictamen);
  }

  /**
   * Indica si existe excepción capturada en la revisión.
   */
  get tieneExcepcionDictamen(): boolean {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return properties?.esExcepcion === true || properties?.esExcepcion === 'true';
  }

  /**
   * Indica si se debe pintar el dictamen de excepción.
   *
   * Aplica para perfiles A, C y D cuando existe nivelExcepcion guardado.
   */
  get esExcepcionPerfilDictamen(): boolean {
    return this.esPerfilConExcepcionDictamen && this.tieneExcepcionDictamen && !!this.nivelExcepcionDictamen?.id;
  }

  /**
   * Indica si la evaluación guardada en la revisión corresponde a "No Aprobado".
   *
   * En catálogo de niveles:
   * id 5 = No Aprobado
   */
  get esNoAprobado(): boolean {
    return this.idEvaluacionParaDictamen === String(this.idNoAprobado);
  }

  /**
   * Indica si se debe pintar el dictamen de NO APROBADO
   * para el Perfil con Énfasis en Investigación de Ciencia Básica
   * y de Frontera o Incidencia.
   *
   * Perfil A = tipoPerfil.id === 'a'
   * No Aprobado = evaluacion.id === '5'
   */
  get esNoAprobadoPerfilInvestigacionCienciaBasica(): boolean {
    return this.tipoPerfilDictamenId === 'a' && this.esNoAprobado;
  }

  get esNoAprobadoPerfilDesarrolloTecnologicoInnovacion(): boolean {
    return this.tipoPerfilDictamenId === 'c' && this.esNoAprobado;
  }

  get esNoAprobadoPerfilMixto(): boolean {
    return this.tipoPerfilDictamenId === 'd' && this.esNoAprobado;
  }

  public guardarDictamen(): void {
    this.$v?.$touch();

    if (
      this.mostrarComentariosDictamenRequerido &&
      (!this.dictamenNegativo?.comentarios ||
        this.caracteresComentarioDictamenNegativo < this.caracteresMinimos ||
        this.caracteresComentarioDictamenNegativo > this.caracteresMaximos)
    ) {
      return;
    }

    const respuesta: any = this.revision?.respuesta || {};
    const propertiesActuales: any = respuesta?.properties || respuesta || {};

    const dictamenEnviar = {
      comentarios: this.dictamenNegativo?.comentarios || '',
    };

    const evaluacionEnviar = this.evaluacionDictamen;

    this.setEvaluacion(evaluacionEnviar);
    this.setDictamen(dictamenEnviar as Dictamen);

    const dictamen2026 = {
      ...propertiesActuales,
      evaluacion: evaluacionEnviar,
      comision: this.comisionDictamen,
      dictamen: dictamenEnviar,
      valido: true,
    };

    this.$emit('guardarDictamen', dictamen2026);
  }

  /**
   * Indica si se debe mostrar y requerir el campo de comentarios
   * para dictámenes de no aprobado, resultado negativo o excepción.
   */
  get mostrarComentariosDictamenRequerido(): boolean {
    return (
      this.esNoAprobadoPerfilInvestigacionCienciaBasica ||
      this.esNoAprobadoPerfilDesarrolloTecnologicoInnovacion ||
      this.esNoAprobadoPerfilMixto ||
      this.esResultadoNegativoPerfilInvestigacionCienciaBasica ||
      this.esResultadoNegativoPerfilDesarrolloTecnologicoInnovacion ||
      this.esResultadoNegativoPerfilMixto ||
      this.esExcepcionPerfilDictamen
    );
  }

  // Resultado negativo (nivel inferior al que ostenta o al que aspira)

  /**
   * Orden jerárquico de niveles SNII.
   *
   * 1 = Candidato
   * 2 = Nivel I
   * 3 = Nivel II
   * 4 = Nivel III
   */
  public get ordenNivelSniiDictamen(): Record<string, number> {
    return {
      '1': 1,
      '2': 2,
      '3': 3,
      '4': 4,
    };
  }

  /**
   * Convierte la clave de vigencia al id usado en evaluación.
   *
   * Vigencia C = Candidato = id 1
   * Vigencia 1 = Nivel I = id 2
   * Vigencia 2 = Nivel II = id 3
   * Vigencia 3 = Nivel III = id 4
   */
  public get equivalenciaVigenciaNivelDictamen(): Record<string, string> {
    return {
      C: '1',
      '1': '2',
      '2': '3',
      '3': '4',
    };
  }

  /**
   * Obtiene el id del nivel al que aspira la persona solicitante.
   */
  public get nivelAspiraIdDictamen(): string {
    return String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');
  }

  /**
   * Obtiene el nombre del nivel al que aspira para el dictamen.
   *
   * El nivel aspirado siempre se toma de la solicitud:
   * solicitudRizomaDictamen.nivelAspira
   *
   * No se toma de la vigencia activa.
   */
  public get nombreNivelAspiraDictamen(): string {
    const nivelId = String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');
    const esFemenino = this.esGeneroFemeninoDictamen;

    const nivelesPorId: Record<string, string> = {
      '1': esFemenino ? 'Candidata' : 'Candidato',
      '2': esFemenino ? 'Investigadora Nacional Nivel I' : 'Investigador Nacional Nivel I',
      '3': esFemenino ? 'Investigadora Nacional Nivel II' : 'Investigador Nacional Nivel II',
      '4': esFemenino ? 'Investigadora Nacional Nivel III' : 'Investigador Nacional Nivel III',
    };

    return nivelesPorId[nivelId] || this.solicitudRizomaDictamen?.nivelAspira?.nombre || '_____';
  }

  /**
   * Indica si la solicitud es Con reconocimiento.
   */
  public get esSolicitudConReconocimientoDictamen(): boolean {
    const tipoSolicitudNombre = String(this.solicitudRizomaDictamen?.tipoSolicitud?.nombre || '').toUpperCase();
    const tipoSolicitudId = String(this.solicitudRizomaDictamen?.tipoSolicitud?.id || '').toUpperCase();

    return tipoSolicitudNombre === 'CON RECONOCIMIENTO' || tipoSolicitudId === 'PERMANENCIA' || tipoSolicitudId === 'PROMOCION';
  }

  /**
   * Obtiene la evaluación guardada para el dictamen.
   */
  public get evaluacionActualDictamen(): any {
    const respuesta: any = this.revision?.respuesta || {};
    const properties: any = respuesta?.properties || {};

    return properties?.evaluacion || {};
  }

  /**
   * Obtiene el id del nivel otorgado en la revisión.
   */
  get nivelOtorgadoIdDictamen(): string {
    return String(this.idEvaluacionParaDictamen || '');
  }

  /**
   * Obtiene las vigencias guardadas en la solicitud.
   *
   * Busca primero dentro de SOLICITUD_RIZOMA.
   * Si no encuentra ahí, busca en la raíz de la solicitud.
   */
  public get vigenciasDictamen(): any[] {
    const solicitudAny: any = this.solicitud || {};

    const vigenciasRizoma = this.solicitudRizomaDictamen?.vigencias || [];
    const vigenciasRaiz = solicitudAny?.vigencias || [];
    const vigenciasProperties = solicitudAny?.properties?.vigencias || [];

    if (Array.isArray(vigenciasRizoma) && vigenciasRizoma.length) {
      return vigenciasRizoma;
    }

    if (Array.isArray(vigenciasRaiz) && vigenciasRaiz.length) {
      return vigenciasRaiz;
    }

    if (Array.isArray(vigenciasProperties) && vigenciasProperties.length) {
      return vigenciasProperties;
    }

    return [];
  }

  /**
   * Obtiene la vigencia activa.
   *
   * Si no encuentra una marca clara de activa/vigente,
   * toma la primera vigencia disponible.
   */
  public get vigenciaActivaDictamen(): any {
    const vigencias = this.vigenciasDictamen;

    if (!vigencias.length) {
      return {};
    }

    const vigenciaActiva = vigencias.find((vigencia: any) => {
      const estado = String(vigencia?.estado || vigencia?.estatus || vigencia?.situacion || '').toUpperCase();

      return (
        vigencia?.activo === true || vigencia?.activa === true || vigencia?.vigente === true || estado === 'ACTIVA' || estado === 'VIGENTE'
      );
    });

    return vigenciaActiva || vigencias[0] || {};
  }

  /**
   * Obtiene el nombre del nivel desde la vigencia activa,
   * ajustando el texto según el género de la persona solicitante.
   */
  public get nombreNivelVigenciaActivaDictamen(): string {
    const vigencia = this.vigenciaActivaDictamen;
    const esFemenino = this.esGeneroFemeninoDictamen;

    if (!vigencia || Object.keys(vigencia).length === 0) {
      return '_____';
    }

    const cveNivelSni = String(vigencia?.cveNivelSni || '').toUpperCase();

    const nivelesPorClave: Record<string, string> = {
      C: esFemenino ? 'Candidata' : 'Candidato',
      '1': esFemenino ? 'Investigadora Nacional Nivel I' : 'Investigador Nacional Nivel I',
      '2': esFemenino ? 'Investigadora Nacional Nivel II' : 'Investigador Nacional Nivel II',
      '3': esFemenino ? 'Investigadora Nacional Nivel III' : 'Investigador Nacional Nivel III',
    };

    if (nivelesPorClave[cveNivelSni]) {
      return nivelesPorClave[cveNivelSni];
    }

    const nivelTexto = String(vigencia?.nivelSni || '').toUpperCase();

    if (nivelTexto.includes('CANDIDATO')) {
      return esFemenino ? 'Candidata a Investigadora Nacional' : 'Candidato a Investigador Nacional';
    }

    if (nivelTexto.includes('NIVEL III')) {
      return esFemenino ? 'Investigadora Nacional Nivel III' : 'Investigador Nacional Nivel III';
    }

    if (nivelTexto.includes('NIVEL II')) {
      return esFemenino ? 'Investigadora Nacional Nivel II' : 'Investigador Nacional Nivel II';
    }

    if (nivelTexto.includes('NIVEL I')) {
      return esFemenino ? 'Investigadora Nacional Nivel I' : 'Investigador Nacional Nivel I';
    }

    return '_____';
  }

  /**
   * Obtiene el nivel que ya ostenta la persona según su vigencia.
   */
  public get nivelOstentaIdDictamen(): string {
    const cveNivelSni = String(this.vigenciaActivaDictamen?.cveNivelSni || '').toUpperCase();

    return this.equivalenciaVigenciaNivelDictamen[cveNivelSni] || '';
  }

  /**
   * Obtiene el nivel de referencia para Resultado negativo.
   *
   * Si es Sin reconocimiento:
   * - normalmente no hay vigencia, entonces toma nivelAspira.
   *
   * Si es Con reconocimiento:
   * - toma el mayor entre nivel que ostenta y nivel al que aspira.
   */
  public get nivelReferenciaResultadoNegativoIdDictamen(): string {
    const nivelAspiraId = this.nivelAspiraIdDictamen;
    const nivelOstentaId = this.nivelOstentaIdDictamen;

    const ordenAspira = this.ordenNivelSniiDictamen[nivelAspiraId] || 0;
    const ordenOstenta = this.ordenNivelSniiDictamen[nivelOstentaId] || 0;

    return ordenOstenta > ordenAspira ? nivelOstentaId : nivelAspiraId;
  }

  /**
   * Resultado negativo general para perfiles A, C y D.
   *
   * Aplica cuando se otorga un nivel inferior al que ostenta
   * o inferior al que aspira.
   */
  public get esResultadoNegativoDictamen(): boolean {
    if (this.esExcepcionPerfilDictamen) {
      return false;
    }

    const perfilesPermitidos = ['a', 'c', 'd'];

    if (!perfilesPermitidos.includes(this.tipoPerfilIdDictamen)) {
      return false;
    }

    const nivelOtorgadoId = this.nivelOtorgadoIdDictamen;

    // Si es No Aprobado u otro valor distinto a Candidato, I, II o III,
    // no entra aquí.
    if (!['1', '2', '3', '4'].includes(nivelOtorgadoId)) {
      return false;
    }

    const ordenOtorgado = this.ordenNivelSniiDictamen[nivelOtorgadoId] || 0;
    const ordenReferencia = this.ordenNivelSniiDictamen[this.nivelReferenciaResultadoNegativoIdDictamen] || 0;

    return ordenReferencia > 0 && ordenOtorgado < ordenReferencia;
  }

  /**
   * Resultado negativo Perfil A.
   */
  get esResultadoNegativoPerfilInvestigacionCienciaBasica(): boolean {
    return this.esResultadoNegativoDictamen && this.tipoPerfilIdDictamen === 'a';
  }

  /**
   * Resultado negativo Perfil C.
   */
  get esResultadoNegativoPerfilDesarrolloTecnologicoInnovacion(): boolean {
    return this.esResultadoNegativoDictamen && this.tipoPerfilIdDictamen === 'c';
  }

  /**
   * Resultado negativo Perfil D.
   */
  get esResultadoNegativoPerfilMixto(): boolean {
    return this.esResultadoNegativoDictamen && this.tipoPerfilIdDictamen === 'd';
  }
  /**
   * Texto del tipo de solicitud para pintar en el dictamen.
   */
  get tipoSolicitudTextoDictamen(): string {
    if (this.esSolicitudSinReconocimientoDictamen) {
      return 'Sin reconocimiento';
    }

    if (this.esSolicitudConReconocimientoDictamen) {
      return 'Con reconocimiento';
    }

    return '_____';
  }

  /**
   * text area
   *
   */

  public readonly $v!: any;

  public readonly caracteresMinimos = CARACTERES_MINIMOS_DICTAMEN;
  public readonly caracteresMaximos = CARACTERES_MAXIMOS_DICTAMEN;

  public dictamenNegativo: any = {
    comentarios: '',
  };

  public tocarComentariosDictamenNegativo(): void {
    this.$v?.dictamenNegativo?.comentarios?.$touch();
  }

  get comentarioDictamenNegativoRequerido(): boolean {
    const campo = this.$v?.dictamenNegativo?.comentarios;

    return campo?.$dirty && !campo?.required;
  }

  get comentarioDictamenNegativoMinimo(): boolean {
    const campo = this.$v?.dictamenNegativo?.comentarios;

    return campo?.$dirty && !campo?.min;
  }

  get comentarioDictamenNegativoMaximo(): boolean {
    const campo = this.$v?.dictamenNegativo?.comentarios;

    return campo?.$dirty && !campo?.max;
  }

  get caracteresComentarioDictamenNegativo(): number {
    return Number(this.dictamenNegativo?.comentarios?.length || 0);
  }

  get caracteresFaltantesDictamenNegativo(): number {
    const faltantes = this.caracteresMinimos - this.caracteresComentarioDictamenNegativo;

    return faltantes > 0 ? faltantes : 0;
  }

  public limitarComentariosDictamenNegativo(): void {
    const comentario = this.dictamenNegativo?.comentarios || '';

    if (comentario.length > this.caracteresMaximos) {
      this.dictamenNegativo.comentarios = comentario.substring(0, this.caracteresMaximos);
    }
  }
}
